import _, { update } from "lodash";
import UUID from "uuid/v4";

export const editLibrary = (
  userId,
  appId,
  currentLib,
  oldCategory,
  updatedCategory
) => {
  if (!updatedCategory.id) {
    updatedCategory.categoryId = UUID();
  }

  updatedCategory.modifiedAt = { nanos: 0, seconds: new Date().getTime() };

  let updatedGroups = currentLib.groups.map((group) => {
    let uGrp = group;

    uGrp.categories = group.categories.map((category) => {
      if (category.categoryId === updatedCategory.id) {
        //Return the updated category instead of the original
        return formatCategoryFromPageResp(updatedCategory, oldCategory.library);
      }
      return category;
    });

    return uGrp;
  });

  let updatedTemplate = {
    appId: appId,
    template: {
      groups: updatedGroups,
      header: currentLib.header,
      templateId: currentLib.templateId,
    },
  };

  return updatedTemplate;
};

const deleteOld = (libraries, oldLibrary) => {
  if (libraries) {
    let index = getGroupIndexFromLibrary(libraries, oldLibrary.categoryName);
    if (index > -1) {
      const categories = libraries.groups[index].categories;
      const indexInstruction = categories.indexOf(oldLibrary.library);
      if (indexInstruction > -1) {
        libraries.groups[index].categories.splice(indexInstruction, 1);
        return libraries;
      }
    } else {
      return libraries;
    }
  } else {
    return {};
  }
};

export const saveNewLibrary = (userId, appId, libraries, newLibrary) => {
  let appTemplate = {
    templateId: libraries.templateId,
    appId,
    template: {
      header: libraries.header,
      expanded: true,
      groups: [],
    },
  };

  const newLibraries = updateLibrariesWithNewLibrary(libraries, newLibrary);

  newLibraries.groups.forEach((group, index) => {
    if (group.categories.length !== 0) {
      appTemplate.template.groups.push(group);
    }
  });

  let isValid = true;
  appTemplate.template.groups.forEach((group, index) => {
    // check if group name is valid
    if (_.isEmpty(group.groupName)) {
      isValid = false;
      return;
    } else {
      // check if all the categories are valid
      group.categories.forEach((category) => {
        if (_.isEmpty(category.categoryName)) {
          isValid = false;
          return;
        }
      });
    }
  });

  if (isValid) {
    return appTemplate;
  } else {
    return null;
  }
};

const updateLibrariesWithNewLibrary = (currentLib, newOrUpdatedCategory) => {
  const grpIdx = getGroupIndexFromLibrary(
    currentLib,
    newOrUpdatedCategory.group ? newOrUpdatedCategory.group : ""
  );

  //If the user manage to skip adding a group -- return null and we will show an error higher up
  if (grpIdx.group === "") return;

  if (grpIdx === -1) {
    let emptyLibrary = {
      groupName: newOrUpdatedCategory.group,
      categories: [
        {
          categoryId: UUID(),
          groupName: newOrUpdatedCategory.group,
          categoryName: newOrUpdatedCategory.name,
          expanded: false,
          categoryDesc: newOrUpdatedCategory.description,
          categoryDescWithFormat: newOrUpdatedCategory.descriptionWithFormat,
          createdAt: { nanos: 0, seconds: new Date().getTime() },
          modifiedAt: { nanos: 0, seconds: new Date().getTime() },
        },
      ],
    };
    if (newOrUpdatedCategory.imageUrl !== "") {
      emptyLibrary.categories[0].imageUrl = newOrUpdatedCategory.imageUrl;
    }
    if (newOrUpdatedCategory.videoUrl !== "") {
      emptyLibrary.categories[0].videoUrl = newOrUpdatedCategory.videoUrl;
    }
    if (newOrUpdatedCategory.youtubeVideo !== "") {
      emptyLibrary.categories[0].youtubeVideo =
        newOrUpdatedCategory.youtubeVideo;
    }
    if (newOrUpdatedCategory.wistiaVideo !== "") {
      emptyLibrary.categories[0].wistiaVideo = newOrUpdatedCategory.wistiaVideo;
    }

    if (newOrUpdatedCategory.defaultReps !== "") {
      emptyLibrary.categories[0].defaultReps = newOrUpdatedCategory.defaultReps;
    }
    if (newOrUpdatedCategory.defaultSets !== "") {
      emptyLibrary.categories[0].defaultSets = newOrUpdatedCategory.defaultSets;
    }
    if (newOrUpdatedCategory.defaultDuration !== "") {
      emptyLibrary.categories[0].defaultDuration =
        newOrUpdatedCategory.defaultDuration;
    }
    if (newOrUpdatedCategory.defaultIntensity !== "") {
      emptyLibrary.categories[0].defaultIntensity =
        newOrUpdatedCategory.defaultIntensity;
    }
    if (newOrUpdatedCategory.defaultFrequency !== "") {
      emptyLibrary.categories[0].defaultFrequency =
        newOrUpdatedCategory.defaultFrequency;
    }

    if (newOrUpdatedCategory.documents !== "") {
      emptyLibrary.categories[0].documents = newOrUpdatedCategory.documents;
    }

    //Add thew newly created group, and the category to the library
    currentLib.groups.push(emptyLibrary);

    //return the full library
    return currentLib;
  } else {
    let i_group = grpIdx;
    let newInstruction = {
      categoryId: UUID(),
      categoryName: newOrUpdatedCategory.name,
      groupName: newOrUpdatedCategory.group,
      expanded: false,
      categoryDesc: newOrUpdatedCategory.description,
      categoryDescWithFormat: newOrUpdatedCategory.descriptionWithFormat,
      createdAt: { nanos: 0, seconds: new Date().getTime() },
      modifiedAt: { nanos: 0, seconds: new Date().getTime() },
    };
    if (newOrUpdatedCategory.imageUrl !== "") {
      newInstruction.imageUrl = newOrUpdatedCategory.imageUrl;
    }

    if (newOrUpdatedCategory.videoUrl !== "") {
      newInstruction.videoUrl = newOrUpdatedCategory.videoUrl;
    }

    if (newOrUpdatedCategory.youtubeVideo !== "") {
      newInstruction.youtubeVideo = newOrUpdatedCategory.youtubeVideo;
    }
    if (newOrUpdatedCategory.wistiaVideo !== "") {
      newInstruction.wistiaVideo = newOrUpdatedCategory.wistiaVideo;
    }

    if (newOrUpdatedCategory.defaultReps !== "") {
      newInstruction.defaultReps = newOrUpdatedCategory.defaultReps;
    }
    if (newOrUpdatedCategory.defaultSets !== "") {
      newInstruction.defaultSets = newOrUpdatedCategory.defaultSets;
    }
    if (newOrUpdatedCategory.defaultDuration !== "") {
      newInstruction.defaultDuration = newOrUpdatedCategory.defaultDuration;
    }
    if (newOrUpdatedCategory.defaultIntensity !== "") {
      newInstruction.defaultIntensity = newOrUpdatedCategory.defaultIntensity;
    }
    if (newOrUpdatedCategory.defaultFrequency !== "") {
      newInstruction.defaultFrequency = newOrUpdatedCategory.defaultFrequency;
    }

    if (newOrUpdatedCategory.documents !== "") {
      newInstruction.documents = newOrUpdatedCategory.documents;
    }
    //update the current group with the current instruction.
    currentLib.groups[i_group].categories.push(newInstruction);

    return currentLib;
  }
};

export const deleteLibrary = (appTemplate, deleteableLib) => {
  if (appTemplate && deleteableLib) {
    const updatedTemplate = deleteOld(appTemplate, deleteableLib);
    return {
      templateId: appTemplate.templateId,
      appId: appTemplate.appId,
      template: {
        header: updatedTemplate.header,
        groups: updatedTemplate.groups,
      },
    };
  } else {
    return null;
  }
};

const getGroupIndexFromLibrary = (library, groupName) =>
  library.groups.map((group) => group.groupName).indexOf(groupName);

export const updateCurrentAppTemplateWithNewInstructionInfo = (
  newOrUpdatedInstruction,
  appTemplate
) => {
  let updatedAppTemplate = appTemplate;

  //see if instruction exists in template:

  return updatedAppTemplate;
};

const formatCategoryFromPageResp = (updatedCat, oldCat) => {
  let instruction = {
    categoryId: updatedCat.id,
    groupName: updatedCat.group,
    categoryName: updatedCat.name,
    categoryDesc: updatedCat.description,
    hasNewVideo:
      updatedCat.videoUrl !== "" && updatedCat.videoUrl !== oldCat.videoUrl,
    categoryDescWithFormat: updatedCat.descriptionWithFormat,
    createdAt: { nanos: 0, seconds: new Date().getTime() },
    modifiedAt: { nanos: 0, seconds: new Date().getTime() },
  };
  if (updatedCat.imageUrl !== "") {
    instruction.imageUrl = updatedCat.imageUrl;
  }

  if (updatedCat.videoUrl !== "") {
    instruction.videoUrl = updatedCat.videoUrl;
  }

  if (updatedCat.wistiaVideo && updatedCat.wistiaVideo.url !== "") {
    instruction.youtubeVideo = updatedCat.youtubeVideo;
  }
  if (updatedCat.wistiaVideo && updatedCat.wistiaVideo.url !== "") {
    instruction.wistiaVideo = updatedCat.wistiaVideo;
  }

  if (updatedCat.defaultReps !== "") {
    instruction.defaultReps = updatedCat.defaultReps;
  }
  if (updatedCat.defaultSets !== "") {
    instruction.defaultSets = updatedCat.defaultSets;
  }
  if (
    updatedCat.defaultDuration !== "" &&
    updatedCat.defaultDuration !== undefined
  ) {
    instruction.defaultDuration = updatedCat.defaultDuration;
  }
  if (
    updatedCat.defaultIntensity !== "" &&
    updatedCat.defaultIntensity !== undefined
  ) {
    instruction.defaultIntensity = updatedCat.defaultIntensity;
  }
  if (
    updatedCat.defaultFrequency !== "" &&
    updatedCat.defaultFrequency !== undefined
  ) {
    instruction.defaultFrequency = updatedCat.defaultFrequency;
  }

  if (updatedCat.documents && updatedCat.documents.length > 0) {
    instruction.documents = updatedCat.documents;
  }

  return instruction;
};



// WEBPACK FOOTER //
// ./src/services/middleware.js